import React from 'react';
import { Container, Row } from 'react-bootstrap';

import PageHeader from "./components/PageHeader";
import ActionHeader from "./components/ActionHeader";
import DataTable from "./components/DataTable";
import UpdateData from "./components/UpdateData";
import TableSelector from "./components/TableSelector";
import useDatabaseTables from "./components/useDatabaseTables";

function UpdatePage() {
  const API_URL = process.env.REACT_APP_API_URL;

  const {
    resultsTable,
    selectedTable,
    setSelectedTable,
    results,
    fetchTableData,
    resetResults
  } = useDatabaseTables(API_URL);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchTableData(selectedTable);
  };

  return (
    <Container className="mt-5">

      <PageHeader title="Aggiornamento riga" />

      {/* Selezione tabella */}
      <TableSelector
        resultsTable={resultsTable}
        selectedTable={selectedTable}
        setSelectedTable={(val) => { setSelectedTable(val); resetResults(); }}
        onSubmit={handleSubmit}
      />

      {/* Tabella dati */}
      {results && results.columns && (
        <Row className='mt-5'>
          <DataTable columns={results.columns} rows={results.rows} />
        </Row>
      )}

      {/* Aggiornamento riga */}
      {results && results.columns && results.rows && (
        <Row className='mt-5 mb-5'>
          <ActionHeader actionTitle="✏️ Aggiorna riga" />
          <UpdateData 
            columns={results.columns} 
            rows={results.rows} 
            tableName={selectedTable} 
            onUpdate={() => fetchTableData(selectedTable)} 
          />
        </Row>
      )}

    </Container>
  );
}

export default UpdatePage;
